<template>
    <router-view id="app" class="page"></router-view>
</template>

<script>
export default {
    data() {
        return {
        };
    }
};
</script>

<style lang="stylus">
.page
    size 100%
</style>
